import { Sidebar as SidebarBase } from "@omni/components/components/Navigation/Sidebar/sidebar";
import { SidebarProps } from "@omni/types/components/props/sidebar.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";
import { useRef } from "react";

import { SidebarComponent } from "@/components/Navigation/Sidebar/sidebar.component";

export const Sidebar = ({
    accountLinks,
    profilelink,
    innerHTML
}: SidebarProps<BaseStore.Etna>) => {
    const contentElementRef = useRef<HTMLDivElement | null>(null);

    return (
        <SidebarBase
            accountLinks={accountLinks}
            profilelink={profilelink}
            innerHTML={innerHTML}
            contentElementRef={contentElementRef}
        >
            <SidebarComponent contentElementRef={contentElementRef} />
        </SidebarBase>
    );
};
